module.exports = __webpack_public_path__ + "img/media_reg_1.e535611d.png";